import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView.js';
import maxCharsTemplate from 'properties/main/max-chars.ejs';

class MainHtmlView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = maxCharsTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        this.model.set('inputTextSettingsTitle', 'Text Input Settings', {silent:true});

        // Add needed property
        var defaultSize = "99";
        if (this.model.attributes.factoryKey === "control_multiple_text_input") {
            defaultSize = "400";
            this.model.set('inputTextSettingsTitle', 'Multiline Text Input Settings', {silent:true});
        }
        else if (this.model.attributes.factoryKey === "control_text_input") {
            defaultSize = "99";
            this.model.set('inputTextSettingsTitle', 'Text Input Settings', {silent:true});
        }

        if (!this.model.get('maxChars')) {
            this.model.set('maxChars', defaultSize, {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        this.delegateEvents();
        return this;
    }

}

export default MainHtmlView;
